import { Alert, CircularProgress, Modal, Snackbar, Box, FormControl, InputLabel } from "@mui/material";
import { useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import styles from "./EsqueceuSenha.module.css";
import { WhiteInput } from "../../../components/Inputs/InputText";
import servLogin from "../../../services/login/servLogin";


const EsqueceuSenha = ({ setOpenPopup }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openSuccessWindow, setOpenSuccessWindow] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [email, setEmail] = useState("");

    const handleCloseSuccess = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenSuccessWindow(false);
        }

        setOpenSuccessWindow(false);
    }

    const handleCloseError = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    const recuperarSenha = async () => {
        try {
            setIsLoading(true);

            await servLogin.recuperarSenha(email);

            setOpenSuccessWindow(true);
            setSuccessMessage("Redefinição enviada com sucesso. Confira seu e-mail.");

            setIsLoading(false);

            setTimeout(() => {
                setOpenPopup(false);
            }, [3000]);
        } catch (err) {
            setIsLoading(false);

            setErrorMessage(err.response.data.Message);
            return setOpenErrorWindow(true);
        } 
    }

    return (
        <div style={{ width: "100%", height: "20%" }}>
            <h4>
                Esqueceu a senha? <br />
                Insira seu e-mail abaixo para receber as instruções para redefinição de senha.
            </h4>
            <div>
                <FormControl variant="outlined" style={{ margin: '20px 0px 20px 35px' }} className={styles.descricao}>
                    <InputLabel shrink style={{ color: "#B8B8B8" }} >
                        E-mail
                    </InputLabel>
                    <WhiteInput 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                            placeholder="E-mail" 
                            type="email"
                        />
                </FormControl>
            </div>
            <div className={styles.botoes}>
                <BlueHoverButton onClick={recuperarSenha}>Recuperar senha</BlueHoverButton>
            </div>

            <Snackbar open={openSuccessWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseSuccess}> 
                    <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
                        {successMessage}
                    </Alert>
            </Snackbar>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { EsqueceuSenha };